"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMarketsMap = void 0;
const sportTypes_1 = require("./sportTypes");
const templateIdsMap_1 = require("./templateIdsMap");
exports.MainMarketsMap = {
    [sportTypes_1.SportTypes.SOCCER]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.BASKETBALL]: templateIdsMap_1.TemplateIdsMap.WINNER_INCL_OVERTIME,
    [sportTypes_1.SportTypes.BASKETBALL_3X3]: templateIdsMap_1.TemplateIdsMap.WINNER_INCL_OVERTIME,
    [sportTypes_1.SportTypes.BASEBALL]: templateIdsMap_1.TemplateIdsMap.WINNER_INCL_EXTRA_INNINGS,
    [sportTypes_1.SportTypes.TENNIS]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.HANDBALL]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.ICE_HOCKEY]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.FLOORBALL]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.BOXING]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.RUGBY]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.AUSSIE_RULES]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.BANDY]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.AMERICAN_FOOTBALL]: templateIdsMap_1.TemplateIdsMap.WINNER_INCL_OVERTIME,
    [sportTypes_1.SportTypes.SNOOKER]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.TABLE_TENNIS]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.DARTS]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.VOLLEYBALL]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.WATERPOLO]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.CURLING]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.FUTSAL]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
    [sportTypes_1.SportTypes.BADMINTON]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.BEACH_VOLLEY]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.BOWLS]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.SQUASH]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.MMA]: templateIdsMap_1.TemplateIdsMap.WINNER,
    [sportTypes_1.SportTypes.BEACH_SOCCER]: templateIdsMap_1.TemplateIdsMap.FULL_TIME_RESULT_1X2,
};
//# sourceMappingURL=mainMarketsMap.js.map